export default __webpack_public_path__ + "static/media/ic-pin-caravana.578fce3d.svg";